import React from 'react';

const StudentAdmssion = () => {
  return <div>Student Admssion is Available in React</div>;
};

export default StudentAdmssion;
